import {FrontDate} from "./frontDate";

export class AppNotificationMessage {

    public static createId() : string {
        return AppNotificationMessage.getUniqueStr();
    }

    public static from(id: string, type: AppNotificationType, message: string, createdAt: FrontDate): AppNotificationMessage {

        return new AppNotificationMessage(
            id,
            type,
            message,
            false,
            createdAt,
        );
    }

    private static getUniqueStr(myStrong?: number) {
        let strong = 1000;
        if (myStrong) {strong = myStrong}
        return new Date().getTime().toString(16)  + Math.floor(strong*Math.random()).toString(16)
    }

    constructor(public readonly id: string,
                public readonly type: AppNotificationType,
                public readonly message: string,
                public isHidden: boolean,
                public readonly createdAt: FrontDate) {
    }
}

export enum AppNotificationType {
    INFO = "Information",
    WARN = "Warning",
    ERROR = "Error",
}



// WEBPACK FOOTER //
// ./src/domain/model/app_notification_message.ts